import React from 'react'
import Notifications from 'components/pages/outboundSettings/notifications/Notifications'
import { NotificationsPageLoader } from 'v2/modules/outboundSettings'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const NotificationsSelector = () => {
  const isRolledOut = isMyFeatureOn(FEATURES.EGD_React_QNS_Admin_Quarantine_Notification_Rollout)
  switch (true) {
    case isRolledOut: {
      return <NotificationsPageLoader />
    }
    default: {
      return <Notifications />
    }
  }
}

export default NotificationsSelector
